'use client';

import { c as _c } from "react/compiler-runtime";
import { ColumnHeading } from '@/lib/types/pageBuilder';
import RecentNews from '../component_astro_crick/RecentNews';
import OnesideText from '../component_astro_crick/OnesideText';
interface SectionHeadingProps {
  heading: ColumnHeading;
  background?: string;
  backgroundImage?: {
    url: string;
    enabled: boolean;
  };
  /** Text color override when using custom background */
  textColor?: string;
}
export default function SectionHeading(t0) {
  const $ = _c(21);
  const {
    heading,
    background,
    backgroundImage,
    textColor
  } = t0;
  if (!heading.enabled) {
    return null;
  }
  const effectiveTextColor = heading.color || textColor;
  const toPx = _temp;
  let t1;
  if ($[0] !== heading.fontSize || $[1] !== heading.fontSizeDesktop || $[2] !== heading.separateFontSize) {
    t1 = heading.separateFontSize ? toPx(heading.fontSizeDesktop) : heading.fontSize;
    $[0] = heading.fontSize;
    $[1] = heading.fontSizeDesktop;
    $[2] = heading.separateFontSize;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const fontSizeDesktop = t1;
  let t2;
  if ($[4] !== heading.fontSize || $[5] !== heading.fontSizeMobile || $[6] !== heading.separateFontSize) {
    t2 = heading.separateFontSize ? toPx(heading.fontSizeMobile) : heading.fontSize;
    $[4] = heading.fontSize;
    $[5] = heading.fontSizeMobile;
    $[6] = heading.separateFontSize;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const fontSizeMobile = t2;
  const hasLinkText = heading.navigation?.enabled && heading.navigation?.linkText;
  let t3;
  if ($[8] !== background || $[9] !== backgroundImage || $[10] !== effectiveTextColor || $[11] !== fontSizeDesktop || $[12] !== fontSizeMobile || $[13] !== hasLinkText || $[14] !== heading.align || $[15] !== heading.fontWeight || $[16] !== heading.level || $[17] !== heading.navigation || $[18] !== heading.showDivider || $[19] !== heading.text) {
    t3 = <div className="">{hasLinkText ? <RecentNews title={heading.text} moreText={heading.navigation.linkText} href={heading.navigation.pageSlug || "#"} background={background} backgroundImage={backgroundImage} textColor={effectiveTextColor} fontSize={fontSizeDesktop} fontSizeMobile={fontSizeMobile} level={heading.level} /> : <OnesideText text={heading.text} href={heading.navigation?.enabled ? heading.navigation?.pageSlug : undefined} background={background} backgroundImage={backgroundImage} textColor={effectiveTextColor} fontSize={fontSizeDesktop} fontSizeMobile={fontSizeMobile} level={heading.level} align={heading.align} fontWeight={heading.fontWeight} showDivider={heading.showDivider} />}</div>;
    $[8] = background;
    $[9] = backgroundImage;
    $[10] = effectiveTextColor;
    $[11] = fontSizeDesktop;
    $[12] = fontSizeMobile;
    $[13] = hasLinkText;
    $[14] = heading.align;
    $[15] = heading.fontWeight;
    $[16] = heading.level;
    $[17] = heading.navigation;
    $[18] = heading.showDivider;
    $[19] = heading.text;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
}
function _temp(n) {
  return typeof n === "number" && Number.isFinite(n) ? `${n}px` : undefined;
}